/**
 * H5 整页冷启判定（适配 Next.js 客户端路由）
 *
 * @description
 * 不使用 performance.navigation；由 GlobalTrackerSync 在任意 pathname 变更时维护。
 * - 当前文档内**首次**路由同步 → H5 冷启（is_cold_start = 1）
 * - 同文档内后续 SPA 切页 → H5 温启（is_cold_start = 0）
 * - 硬刷新会重置模块状态，再次视为冷启
 *
 * reader_perf（reader/utils/reader-perf-timing）在 initReaderPerfFromUrl 时通过 consumeH5ColdStart 读取快照。
 */

/** 当前文档是否已做过至少一次 pathname 同步 */
let hasSyncedPathnameInDocument = false;

/**
 * H5 冷启快照：1 冷启，0 温启；同文档内随 SPA 跳转由 1 降为 0
 * reader perf init 消费后不再变更
 */
let h5ColdStartSnapshot: number | null = null;

/**
 * 任意 pathname 变更时调用（GlobalTrackerSync useLayoutEffect，早于页面子树）
 * @returns 是否为当前文档内首次 pathname 同步（H5 冷启入口）
 */
export function onH5PathnameChange(): boolean {
    if (!hasSyncedPathnameInDocument) {
        hasSyncedPathnameInDocument = true;
        h5ColdStartSnapshot = 1;
        return true;
    }

    if (h5ColdStartSnapshot === 1) {
        h5ColdStartSnapshot = 0;
    }
    return false;
}

/**
 * 阅读器性能 init 时消费 H5 冷启快照
 */
export function consumeH5ColdStart(): number {
    if (h5ColdStartSnapshot !== null) {
        return h5ColdStartSnapshot;
    }
    return hasSyncedPathnameInDocument ? 0 : 1;
}
